<template>
  <div>
    <loading v-if="isLoading" :isLoading="isLoading"></loading>
    <bread-crumb :routeName="'Careers'"></bread-crumb>
    <hero :backgroundImage="slide_image" :content="slider_text" :top="true">
    </hero>
    <div class="container">
      <section class="section">
        <p class="is-white subtitle is-5 m-b-50" v-html="description"></p>
        <div class="columns m-b-10 is-multiline">
          <div class="column is-6" v-for="career in careers">
            <ul>
              <li class="is-white subtitle is-bold is-5">{{ career.value }}</li>
            </ul>
          </div>
        </div>
      </section>
    </div>
  </div>
</template>

<script>
export default {
  created() {
    this.axios
      .get(
        `https://${this.baseURL()}/api/singletons/get/careers?token=8864674b01000e6d7d030ef8c41e72`
      )
      .then((data) => {
        console.log(data.data);
        this.description = data.data["descriptn"];
        this.careers = data.data["careers"];
        this.slider_text = data.data["slider_text"];
        this.slide_image = `https://${this.baseURL()}${
          data.data["slider_image"]["path"]
        }`;
        // subscribe to loading event to know how many images are loading
        this.$on("loading", () => {
          this.isLoading = true;
          this.loading++;
        });

        // detect when loading is finished
        this.$on("loaded", () => {
          this.loaded++;
          // working dynamically regardless of how many images are on page!
          if (this.loaded === this.loading) this.isLoading = false;
        });
      });
  },
  data() {
    return {
      description: " ",
      slide_image: "#",
      careers: " ",
      slider_text: " ",
      loading: 0,
      loaded: 0,
      isLoading: false,
    };
  },
};
</script>

<style scoped lang="scss">
@import "../../assets/scss/vars";
.section /deep/ a {
  color: $red !important;
  font-weight: normal !important;
}
ul {
  list-style-type: disc;
  li {
    display: list-item;
  }
  margin-left: 20px !important;
}
</style>



// WEBPACK FOOTER //
// careers.vue?767cf302